import {
    TimeSeriesChartDataItem,
    TimeSeriesChartData,
} from 'utils/components/TimeSeriesChart/TimeSeriesChartData';

export interface IntraDayProfileDataItem extends TimeSeriesChartDataItem {
    bucketStartTime: number;
    bucketEndTime: number;
    auctionVolume?: number;
    actualTradedVolume?: number;
    cumulativeTradedVolume?: number;
    historicalTradedVolume?: number;
    historicalCumulativeTradedVolume?: number;
    historicalAuctionAndTradedVolume?: number;
    historicalSpread?: number;
    historicalVolatility?: number;
    barWidthPercentage?: number;
}

export type IntraDayProfileData = TimeSeriesChartData<IntraDayProfileDataItem>;

export const getBucketIncludingTime = (
    dataSeries: IntraDayProfileDataItem[],
    t: number
) => dataSeries.find((x) => x.bucketStartTime <= t && t < x.bucketEndTime);
